<template>
  <div
    class="mb-12"
    :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <div class="mt-3 background-default pa-7">
      <div>
        <div class="title text--secondary mb-5">
          Tambah Kelas
        </div>
        <ValidationObserver ref="observer">
          <v-form>
            <ValidationProvider
              name="Judul"
              rules="required|max:70"
              v-slot="{ errors }">
              <v-text-field
                outlined
                dense
                color="#ff618a"
                label="Judul"
                counter="70"
                v-model="form.classesTitle"
                :error-messages="errors"
                required>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider
              name="Kategori"
              rules="required"
              v-slot="{ errors }">
              <v-select
                dense
                outlined
                color="#ff618a"
                label="Kategori"
                :items="category"
                item-text="categoryTitle"
                item-value="id"
                v-on:change="changeCategory"
                v-model="form.classesCategoryId"
                :error-messages="errors"
                required>
              </v-select>
            </ValidationProvider>
            <div v-if="Object.keys(detail).length > 0 ? detail.classesType==='private' ? detail.classesIsCheckout=='no' : detail.classesJoin.length < 1 : Object.keys(detail).length < 1">
            <ValidationProvider name="Type" rules="required" v-slot="{ errors }">
                <v-select
                  :items="[
                    {
                      title: 'Public', 
                      value: 'public'
                    },
                    {
                      title: 'Private', 
                      value: 'private'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  dense
                  :disabled="detail.classesIsCheckout ==='yes'"
                  outlined
                  color="#ff618a"
                  label="Tipe"
                  v-model="form.classesType"
                  :error-messages="errors"
                  require>
                </v-select>
            </ValidationProvider>
             </div>
            <div v-if="Object.keys(detail).length > 0 ? detail.classesType==='private' ? detail.classesIsCheckout=='no' : detail.classesJoin.length < 1 : Object.keys(detail).length < 1" >
            <v-label>
              Harga
            </v-label>
            <v-radio-group class="mt-1" v-model="price">
              <v-radio label="Berbayar" value="non-free" color="#ff618a">
              </v-radio>
              <v-row v-if="price === 'non-free'">
                <v-col cols="12" md="6">
                  <ValidationProvider
                    name="Harga"
                    rules="required|min_10000:10000|max_classPrice:100000000"
                    v-slot="{ errors }">
                     <v-currency-field 
                      outlined
                      dense
                      color="#ff618a"
                      type="number"
                      label="Harga"
                      :prefix="`Rp`"
                      v-model="form.classesPrice"
                      :error-messages="errors"
                      required/>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6">
                  <ValidationProvider
                    name="Diskon"
                    rules="min_0:0|max_100:100"
                    v-slot="{ errors }">
                    <v-text-field
                      outlined
                      dense
                      :disabled="detail.classesIsCheckout ==='yes'"
                      color="#ff618a"
                      type="number"
                      label="Diskon"
                      v-model="form.classesDiscount"
                      :error-messages="errors">
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-radio label="Gratis" value="free" color="#ff618a" class="mb-0">
              </v-radio>
              <v-card-text
                class="caption text-justify py-1 ml-4 font-italic"
                v-if="price === 'free'">
                Kelas anda sekarang berstatus <b>Gratis</b>, sehingga pengguna
                dapat mengambil secara gratis. Apakah anda yakin untuk membuat
                kelas gratis ?
              </v-card-text>
            </v-radio-group>
             </div>
            <!-- <div v-if="detail.classesIsCheckout === 'no'"> -->
              <!--   -->
            <div v-if="detail.classesIsCheckout === 'no' && price ==='non-free' || Object.keys(detail).length === 0 && price ==='non-free'" v-show="form.classesType !== 'public'">
            <v-label>
              Angsuran
            </v-label>
            <v-row>
              <v-col cols="12" md="2" v-for="(category,index) in check" :key="index">
               <v-checkbox v-model="form.classesSelected" :label="category.title" :value="category"  :disabled="detail.classesIsCheckout ==='yes'"></v-checkbox>
              </v-col>
            </v-row>
             <p class="caption mt-1 mb-1 red--text" v-show="error.classesSelected">
              {{ error.classesSelected }}
            </p>
            </div>
            <v-row>
              <v-col cols="12" sm="3">
                <v-menu
                  ref="menustart"
                  v-model="menu.menuStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  class="z-my"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.startDate"
                      label="Tanggal Mulai"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      hide-details
                      color="#ff618a"
                      v-on="on">
                    </v-text-field>
                  </template>
                  <v-date-picker 
                    v-model="form.startDate" 
                    :min="reminder" 
                    v-on:change="startdate" 
                    color="#ff618a"
                    @input="menu.menuStart = false">
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="3">
                <v-menu
                  ref="menuTimeStart"
                  v-model="form.startTime"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="form.timeStart"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.timeStart"
                      label="Waktu Mulai"
                      prepend-inner-icon="mdi-clock"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      hide-details
                      color="#ff618a"
                      v-on="on"
                      :disabled="form.startDate === ''"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="form.startTime"
                    v-model="form.timeStart"
                    full-width
                    color="#ff618a"
                    @click:minute="$refs.menuTimeStart.save(form.timeStart)"
                  ></v-time-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="3">
                <v-menu
                  ref="menuend"
                  v-model="menu.menuEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  class="z-my"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.endDate"
                      label="Tanggal Berakhir"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      hide-details
                      color="#ff618a"
                      :disabled="form.timeStart === ''"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.endDate"
                    :min="form.startDate"
                    color="#ff618a"
                    v-on:change="enddate"
                    @input="menu.menuEnd = false">
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="3">
                <v-menu
                  ref="menuTimeEnd"
                  v-model="form.endTime"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="form.timeEnd"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.timeEnd"
                      label="End Time"
                      prepend-inner-icon="mdi-clock"
                      readonly
                      dense
                      outlined
                      color="#ff618a"
                      v-bind="attrs"
                      :disabled="form.endDate === ''"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="form.endTime"
                    v-model="form.timeEnd"
                    full-width
                    color="#ff618a"
                    @click:minute="$refs.menuTimeEnd.save(form.timeEnd)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>

            <!-- <video-input v-model="video">
              <div slot="activator">
                <v-text-field
                  :label="`Video Overview`"
                  color="#ff618a"
                  :hide-details="true"
                  :placeholder="form.classesOverview"
                  outlined
                  dense
                >
                </v-text-field>
              </div>
            </video-input>
            <div class="caption mt-1 font-italic font-weight-light grey--text text--darken-1">
              *note: Maksimal file 200MB
            </div>
            <p class="caption text-left mt-1 red--text" v-show="error.classesOverview">
              {{ error.classesOverview }}
            </p> -->

            <p class="mb-1 mt-3">Deskripsi</p>
            <quill-editor
              ref="myTextEditor"
              v-model="form.classesDesc"
              :options="option">
            </quill-editor>
            <p class="caption mt-1 mb-1 red--text" v-show="error.classesDesc">
              {{ error.classesDesc }}
            </p>

            <div class="mb-3 mt-5">
              <p class="mb-2">Video Overview</p>
              <form class="mt-1">
                <v-card
                flat
                width="400"
                height="250"
                class="pa-0"
                style="background: transparent;"
                >
                <video-input v-model="video">
                  <div slot="activator">
                    <v-avatar
                    width="400"
                    max-width="340"
                    height="220"
                    class="grey lighten-3 cursor-pointer"
                    v-ripple
                    tile
                    v-if="!video || video.url === undefined">
                    <v-icon v-if="!video && addVideo === ''" color="grey darken-3" large>mdi-video-plus</v-icon>
                    <div v-if="addVideo && video.url === undefined">
                      <v-progress-linear
                        color="#ff618a"
                        indeterminate
                        rounded
                        height="6"
                        style="width: 200px;">
                      </v-progress-linear>
                        <p class="caption mt-2 mb-0">
                          Mengupload video . . .
                        </p>
                    </div>
                    </v-avatar>
                  </div>
                </video-input>
                <p class="caption text-left mt-1 red--text"
                  v-show="error.classesOverview">
                  {{ error.classesOverview }}
                </p>
                <video
                  id="myVideo"
                  height="200px"
                  width="100%" 
                  :src="video.url"
                  playsinline 
                  controls
                  v-if="video && !addVideo">
                </video>
                <video-input v-model="video" >
                  <div slot="activator">
                    <v-btn
                      rounded
                      light
                      width="100%"
                      color="#ff618a"
                      elevation="0"
                      :disabled="addVideo || process.run"
                      :loading="addVideo"
                      v-if="addVideo !== '' && video.url !== undefined"
                      class="white--text text-capitalize">
                      Ganti Video
                    </v-btn>
                  </div>
                </video-input>
                </v-card>
              </form>
            </div>

            <div class="mb-3 mt-5">
              <p class="mb-2">Gambar Sampul</p>
              <form class="mt-1">
                <v-card
                  flat
                  width="250"
                  height="250"
                  class="pa-0"
                  style="background: transparent;"
                >
                  <image-input v-model="avatar" type="uploadCover">
                    <div slot="activator">
                      <v-avatar
                        width="250"
                        height="250"
                        class="grey lighten-3 c-p"
                        v-ripple
                        tile>
                         <v-icon v-if="!avatar && addImage === ''" color="grey darken-3"  large>mdi-camera</v-icon>
                        <div v-if="addImage && avatar.url === undefined">
                          <v-progress-linear
                            color="#ff618a"
                            indeterminate
                            rounded
                            height="6"
                            style="width: 200px;">
                          </v-progress-linear>
                          <p class="caption mt-2 mb-0">
                            Mengupload Gambar . . .
                          </p>
                        </div>
                        <img
                          v-if="avatar && !addImage"
                          :src="form.classesCover"
                          :alt="form.classesCover"
                        />
                      </v-avatar>
                    </div>
                  </image-input>
                </v-card>
              </form>
              <p class="caption text-left mt-1 red--text"
                v-show="error.classesCover">
                {{ error.classesCover }}
              </p>
            </div>
            <div>
              <v-alert
                type="error"
                text
                dense
                prominent
                v-show="response !== ''"
              >
                {{ response }}
              </v-alert>
            </div>
            <v-card-actions class="mt-5">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                light
                :width="$vuetify.breakpoint.name === 'lg' ? '200' : '100'"
                color="#FF618A"
                elevation="0"
                :disabled="process.run"
                :loading="process.run"
                @click="save"
                class="white--text text-capitalize"
              >
                Simpan
              </v-btn>
              <v-btn
                rounded
                light
                outlined
                :width="$vuetify.breakpoint.name === 'lg' ? '200' : '100'"
                elevation="0"
                :disabled="process.run"
                class="text-capitalize"
                to="/class"
              >
                Batal
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { get, post, put, destroy } from "../../../service/Axios";
import ImageInput from "../../../components/ImageInput.vue";
import VideoInput from "../../../components/VideoInput.vue";
// import Moment from 'moment'
export default {
  data() {
    return {
      option: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
        placeholder: "Deskripsi . . .",
      },
      // selected:[],
      check:[
        {
          value:1,
          title:'1 kali'
        },
        {
          value:2,
          title:'2 kali'
        },
        {
          value:3,
          title:'3 kali'
        },
        {
          value:4,
          title:'4 kali'
        },
        {
          value:5,
          title:'5 kali'
        },
        {
          value:6,
          title:'6 kali'
        },
      ],
      endtimemin: '',
      starttimemin: '',
      menu: {
        menuStart: false,
        menuEnd: false,
      },
      detail: {},
      category: [],
      avatar: null,
      video: null,
      addVideo: "",
      addImage: "",
      price: "non-free",
      form: {
        classesTitle: "",
        classesCategoryId: "",
        classesCategoryTitle: "",
        classesDesc: "",
        classesOverview: "",
        classesPrice: "",
        classesType:"",
        classesCover:"",
        classesDiscount: 0,
        classesSelected:[],
        startDate: "",
        endDate: "",
        timeEnd:'',
        timeStart:'',
        startTime:false,
        endTime:false,
      },
      error: {
        classesCover: "",
        classesOverview: "",
        classesDesc: "",
        classesSelected:"",
      },
      process: {
        run: false,
      },
      response: "",
    };
  },
  head() {},
  watch: {
    avatar: {
      handler: function() {
        this.form.classesCover = this.avatar.url;
        this.addImage = this.avatar.add
        this.error.classesCover = "";
      },
      deep: true,
    },
    video: {
      handler: function() {
        this.form.classesOverview = this.video.url;
        this.addVideo = this.video.add
        this.error.classesOverview = "";
      },
      deep: true,
    },
      options: {
        handler() {
          this.initialize();
        },
        deep: true
    },
  },
  components: {
    ImageInput,
    VideoInput,
  },
  computed: {
    reminder () {
      let now = new Date(),
          next = new Date(now)
      next.setDate(now.getDate())
      return next.toISOString().substr(0, 10)
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this.$route.query.id !== undefined) {
      this.fetch();
    } else {
      this.fetchCategory();
    }
  },
  methods: {
    async fetch() {
      await get(`api/internal/class/detail/${this.$route.query.id}`).then(
        (response) => {
          if (response.data.code === 200) {
            this.detail = response.data.data;
            this.fetchCategory();
            this.reset();
          }
        }
      );
    },
    async fetchCategory() {
      this.process.run = true;
      await get(`api/internal/category/list`).then((response) => {
        let res = response.data;
        if (res.code === 200) {
          this.category = res.data;
        }
        this.process.run = false;
      });
    },
    changeCategory() {
      for (let i in this.category) {
        if (this.category[i].id === this.form.classesCategoryId) {
          this.form.classesCategoryTitle = this.category[i].categoryTitle;
        }
      }
    },
    reset(id, page) {
      this.avatar = {
        url: this.detail.classesUrlCover,
      };
      this.video = {
        url: this.detail.classesUrlOverview,
      };
      this.form = {
        classesTitle: this.detail.classesTitle,
        classesCategoryId: this.detail.classesCategoryId,
        classesCategoryTitle: this.detail.classesCategoryTitle,
        classesDesc: this.detail.classesDesc.replace(/&lt;/g, "<"),
        classesPrice:this.detail.classesPrice === 0 ? (this.price = "free"): (this.price = "non-free"),
        classesCover: this.detail.classesUrlCover,
        classesDiscount: this.detail.classesDiscount,
        classesOverview: this.detail.classesUrlOverview === null ? "" : this.detail.classesUrlOverview,
        classesSelected: this.detail.classesInstallment,
        classesType:this.detail.classesType,
        startDate: this.$callbackdate(this.detail.classesStartDatetime),
        endDate: this.$callbacktime(this.detail.classesEndDatetime),
        timeEnd:this.$callbackdate(this.detail.classesEndDatetime),
        timeStart:this.$callbacktime(this.detail.classesStartDatetime)
      };
      if (this.price === 'non-free') {
        this.form.classesPrice = this.detail.classesPrice
      } else {
        this.form.classesPrice = 0
      }
    },
    startdate(){
      let today = new Date()
      let time = today.getHours()+ ":" + today.getMinutes()+ ":" + today.getSeconds();
      if(this.form.startDate === this.reminder){
        this.starttimemin = time
      }else{        
        this.starttimemin = ''
      }
      this.form.timeStart = ''
      this.form.endDate = ''
      this.form.timeEnd = ''
    },
    starttime(){
      this.form.endDate = ''
      this.form.timeEnd = ''
    },
    enddate(){
      if(this.form.endDate === this.form.startDate){
        this.endtimemin = this.form.startDate
      }else{
         this.endtimemin = ''
      }
    },
    validation() {
      var error = this.error,
        valid = true;

      if (this.form.classesDesc === "") {
        error.classesDesc = "Kolom tidak boleh kosong";
        valid = false;
      } else {
        error.classesDesc = "";
      }
      if (this.form.classesSelected === "") {
        error.classesDesc = "Kolom tidak boleh kosong";
        valid = false;
      } else {
        error.classesSelected = "";
      }

      if (this.form.classesOverview === '') {
          error.classesOverview = 'Video tidak boleh kosong'
          valid = false
        } else if (this.form.classesOverview === undefined) {
          error.classesOverview = 'Video tidak boleh kosong'
          valid = false
        } else {
          error.classesOverview = ''
        } 

        if (this.form.classesCover === '') {
          error.classesCover = 'Gambar tidak boleh kosong'
          valid = false
        } else if (this.form.classesCover === undefined) {
          error.classesCover = 'Gambar tidak boleh kosong'
          valid = false
        } else {
          error.classesCover = ''
        }

      return valid;
    },
    async save() {
      this.response = "";
      const valids = this.validation();
      const isValid = await this.$refs.observer.validate();
      if (isValid && valids) {
        if (this.$route.query.id === undefined) {
          this.creates();
        } else {
          this.updates();
        }
      }
    },
    async creates() {
      this.process.run = true;
      await post(`api/internal/class/create`, {
        data: {
          classesTitle: this.form.classesTitle,
          classesDesc: this.form.classesDesc,
          classesCategoryId: this.form.classesCategoryId,
          classesCategoryTitle: this.form.classesCategoryTitle,
          classesType:this.form.classesType,
          classesUrlCover: this.form.classesCover,
          classesUrlOverview: this.form.classesOverview,
          classesPrice: this.price === "free" ? 0 : this.form.classesPrice,
          classesDiscount: this.form.classesDiscount === "" ? 0 : this.price === "free" ? 0 : this.form.classesDiscount,
          classesStartDatetime: this.$timezones(`${this.form.startDate}  ${this.form.timeStart}`),
          classesEndDatetime:  this.$timezones(`${this.form.endDate}  ${this.form.timeEnd}`),
          classesInstallment: this.form.classesSelected
          // classesInstallment: this.detail.classesIsCheckout === 'no' ? this.form.classesSelected : this.detail.classesInstallment
        },
      }).then((response) => {
        let res = response.data;
        if (res.code === 201) {
          window.location = `/class/${res.data}`;
        } else {
          this.process.run = false;
          this.response = res.msg;
        }
      });
    },
    async updates() {
      this.process.run = true;
      await put(`api/internal/class/update/${this.$route.query.id}`, {
        data: {
          classesTitle: this.form.classesTitle,
          classesDesc: this.form.classesDesc,
          classesCategoryId: this.form.classesCategoryId,
          classesCategoryTitle: this.form.classesCategoryTitle,
          classesUrlCover: this.form.classesCover,
          classesUrlOverview: this.form.classesOverview,
          classesType:this.form.classesType,
          classesPrice: this.price === "free" ? 0 : this.form.classesPrice,
          classesDiscount: this.form.classesDiscount === "" ? 0 : this.price === "free" ? 0 : this.form.classesDiscount,
          classesStartDatetime: this.$timezones(`${this.form.startDate}  ${this.form.timeStart}`),
          classesEndDatetime:  this.$timezones(`${this.form.endDate}  ${this.form.timeEnd}`),
          classesInstallment: this.detail.classesIsCheckout === 'yes' ? this.detail.classesInstallment : this.form.classesSelected
        },
      }).then((response) => {
        if (response.data.code === 201) {
          const url = `/class/${this.$route.query.id}`;
          this.$router.push(url);
        } else {
          this.process.run = false;
          this.response = response.data.msg;
        }
      });
    },
  },
};
</script>
